import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import numeral from 'numeral';

import styles from './styles.module.scss';

import { updateWorkTime } from '../../../api'

import Textarea from '../../Core/Textarea/Textarea';

const formatNumbers = (value) => {
  const cleaned = value.replace(/[^0-9:.,]/g, '').replace(/,/g, '.')
  const firstDot = cleaned.indexOf('.');
  if (firstDot === -1) return cleaned;
  return cleaned.slice(0, firstDot + 1) + cleaned.slice(firstDot + 1).replace(/\./g, '');
}

const EditBonus = forwardRef(({companyId, onUpdate}, ref) => {

  const { t } = useTranslation();
  
  const [isOpen, setIsOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [form, setForm] = useState({value: '0.00', bonus_comment: ''})

  useImperativeHandle(ref, () => ({
    open: ({value, data}) => {
      setForm(prev => ({
        ...prev,
        value: value || '0.00',
        data: data || {},
      }))
      // setLoading(false)
      setIsOpen(true)
    },
    close: handleClose
  }))

  const handleSubmit = async () => {
    const post = {
      additional_bonus: numeral(form.value).value(),
      bonus_comment: form.bonus_comment
    }
    setLoading(true)
    await updateWorkTime(companyId, form.data.id, post)
    setLoading(false)
    onUpdate()
    handleClose()
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  const handleChangeForm = ({target}) => {
    const { value } = target
    setForm(prev => ({...prev, value: formatNumbers(value)}))
  }

  return (
    <Dialog
      onClose={handleClose}
      open={isOpen}
      maxWidth='xs'
      classes={{ paper: styles.modal }}
    >
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.label}>{t('Bonus')}</div>
          <IconButton aria-label='close' onClick={handleClose} className={styles.closeButton}>
            <CloseIcon />
          </IconButton>
        </div>
        <input
          label={t('Additional Bonus')}
          value={form.value}
          onChange={handleChangeForm}
          className={styles.input}
        />
        <Textarea
          label={t('Bonus comment')}
          placeholder={t('If needed make a note why this action is taken.')}
          onChange={e => {
            const { value } = e.target
            setForm(prev => ({...prev, bonus_comment: value}))
          }}
          name='bonus_comment'
          value={form.bonus_comment}
        />
      </div>
      <div>
        <button onClick={handleSubmit} disabled={loading} className={styles.buttonSave}>
          { loading ? <div className={styles.loader} /> : t('Save & Close') }
        </button>
      </div>
    </Dialog>
  )
})

export default EditBonus
